import { Controller } from "@hotwired/stimulus"

// Copies text to clipboard with toast feedback.
// Usage: <button data-controller="clipboard" data-clipboard-text-value="text to copy" data-action="clipboard#copy">Copy</button>
export default class extends Controller {
  static values = { text: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      document.dispatchEvent(new CustomEvent("toast:show", {
        detail: { message: "Copied to clipboard", type: "success" }
      }))
    } catch {
      // Fallback for older browsers
      const textarea = document.createElement("textarea")
      textarea.value = this.textValue
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
      document.dispatchEvent(new CustomEvent("toast:show", {
        detail: { message: "Copied to clipboard", type: "success" }
      }))
    }
  }
}
